import React from 'react';
import { Form, DatePicker, Input, Checkbox, Select, Divider } from 'antd';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

import AddEditStore from './store';
import { formatDate } from '../../../utils/functions';
import moment from 'moment';

@observer
class ActionRequired extends React.Component {
  convertDate = dateString => {
    if (dateString) {
      if (typeof dateString === 'string') {
        if (dateString.search('/Date') !== -1) {
          const dateFormat = formatDate(dateString);
          return moment(dateFormat, 'DD MMM,YYYY');
        }
      } else {
        return moment(dateString, 'DD/MM/YYYY');
      }
    }
    return null;
  };
  checkIsJSON = value => {
    try {
      JSON.parse(value);
    } catch (e) {
      return false;
    }
    return true;
  };
  render() {
    const data = toJS(AddEditStore.clientInfo);
    const { staffList } = AddEditStore;
    return (
      <Form name="action-required-form">
        <div className="fluid-field" style={{ marginBottom: '1.5em' }}>
          <Checkbox
            checked={data.ActionRequired}
            onChange={AddEditStore.handleChecked('ActionRequired')}
          >
            Action required
          </Checkbox>
        </div>
        <Form.Item label="Due Date">
          <DatePicker
            size="large"
            value={this.convertDate(data.DueDate)}
            onChange={AddEditStore.handleFieldChange('DueDate')}
            format="DD/MM/YYYY"
          />
        </Form.Item>
        <Form.Item label="Action notes" className="fluid-field">
          <Input.TextArea
            rows={6}
            value={data.ActionNotes}
            onChange={AddEditStore.handleFieldChange('ActionNotes')}
          />
        </Form.Item>
        <Divider className="fluid-field" />
        <Form.Item label="PIC">
          <Select
            size="large"
            value={data.StaffId}
            onChange={AddEditStore.handleFieldChange('StaffId')}
          >
            {staffList &&
              this.checkIsJSON(staffList) &&
              JSON.parse(staffList).itemList.map(i => (
                <Select.Option key={i.id} value={i.id}>
                  {i.fullName}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <div className="fluid-field">
          <Checkbox
            checked={data.ActionCompleted}
            onChange={AddEditStore.handleChecked('ActionCompleted')}
          >
            Action completed
          </Checkbox>
        </div>
        {toJS(data.ActionCompleted) && (
          <Form.Item label="Due Date">
            <DatePicker
              size="large"
              value={this.convertDate(data.CompletedDate)}
              onChange={AddEditStore.handleFieldChange('CompletedDate')}
              format="DD/MM/YYYY"
            />
          </Form.Item>
        )}
      </Form>
    );
  }
}

export default ActionRequired;
